module.exports = __webpack_public_path__ + "img/front buttons quantity.cd292fa5.png";